module.exports = __webpack_public_path__ + "static/bg-bc2c2ed6589f435461e32401b8963df3.png";